import axios from 'axios'

async function edit_template(dispatch,token,templates,add_template,add_templates,setOpen,setMessage,data,setLoading,navigate){
try {
    setLoading(true)

    const editTemplate = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}edit-template/`,data,{
         headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${token}`
            }
     }).catch(err=>{console.log(err)})

    if (editTemplate?.status == 200 && editTemplate?.data.success) {

        const newData = [...templates?.filter(item=>item?.id !== data?.id),editTemplate?.data.template]

        await dispatch(add_templates(newData))
        await dispatch(add_template(editTemplate?.data.template))
        localStorage.setItem("iTest_template",JSON.stringify(editTemplate?.data?.template))

        setMessage("Template edited")
        setOpen(true)
        setLoading(false)
        navigate("/templateInfo")

    }else{
      setMessage(editTemplate?.data?.message)
      setOpen(true)
      setLoading(false)
    }
} catch (error) {
    console.log(error)
}

}

export default edit_template